<template>
  <div class="userinfo flex items-center">
    <el-image
      :class="avatarCls"
      :style="{ width: _size + 'rem', height: 'auto' }"
      :src="user.avatar"
      :alt="user.name"
    >
      <div slot="error" class="image-slot flex justify-center items-center">
        {{ avatarLabel }}
      </div>
    </el-image>
    <!-- 用户名 -->
    <span class="userinfo__reference__account">
      {{ user.name }}
      <span v-if="user.scoreAi !== undefined && user.scoreAi !== null">
        ({{ user.scoreAi }})
      </span>
    </span>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'UserAvatar',
  props: {
    user: {
      type: Object,
      default() {
        return { avatar: '', name: '' }
      },
    },
    type: {
      type: String,
      default: 'round',
    },
    size: {
      type: Number,
      default: 40,
    },
  },
  data() {
    return {}
  },
  components: {},
  computed: {
    avatarLabel() {
      const account = _.get(this, 'user.name', 'C')
      return account.slice(0, 1)
    },
    avatarCls() {
      return {
        flex: true,
        userinfo__avatar: true,
        round: this.type === 'round',
        'flex-shrink-0': true,
      }
    },
    _size() {
      return this.size / 100
    },
  },
  async mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.userinfo {
  &__avatar {
    display: block;
    width: val(40);
    height: val(40);
    &.round {
      border-radius: 50%;
    }

    ::v-deep {
      .image-slot {
        width: 100%;
        height: 100%;
        font-size: val(24);
        color: var(--black-color-3);
      }
    }
  }
  &__reference {
    min-height: 100%;

    &__account {
      font-size: val(24);
      margin-left: val(8);
      line-height: val(30);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
